module.exports = __webpack_public_path__ + "img/solid-interoperability.0c8689e3.png";